import fetchContentType from 'src/lib/Strapi/fetchContentType'
import spreadStrapiData from 'src/lib/Strapi/spreadStrapiData'

/**
 * Fetches integration cards data, processing each card to ensure proper link text.
 *
 * @param {Object} options - Options for fetching integration cards.
 * @param {string} options.buttonText - Default button text for the card links.
 * @param {number} [options.page=1] - Current page number for pagination.
 * @param {number} [options.limit=6] - Number of items per page.
 * @return {Promise<Object>} An object containing the count of cards, category ID, and integrations data.
 */
export async function fetchIntegrationsCardCategory({
  buttonText,
  page = 1,
  limit = 6,
}) {
  try {
    // Fetch integration content using the specified limit and page
    const data = await fetchContentType(
      'integrations',
      `pagination[pageSize]=${limit}&pagination[page]=${page}`,
      false
    )

    const meta = data.meta
    const spreadedIntegrations = spreadStrapiData(data)

    // Process each card to format the link object
    const integrations = spreadedIntegrations.map((card) => {
      if (!card.isExternal && card.slug) {
        return {
          ...card,
          link: {
            href: `/integrations/${card.slug}`,
            text: card.link?.text || buttonText,
          },
        }
      }

      return {
        ...card,
        link: card.link
          ? { ...card.link, text: card.link.text || buttonText }
          : { text: buttonText },
      }
    })

    // Extract the total number of cards from the response metadata
    const cardsCount = meta.pagination.total

    return {
      count: cardsCount,
      categoryId: null, // Placeholder for category ID if applicable
      integrations,
    }
  } catch (error) {
    // Log any errors that occur during fetching
    console.error('FetchIntegrationsCardCategoryError', error)
  }
}
